module.exports = __webpack_public_path__ + "static/media/barryCunningham.ce4468a5.jpg";